import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function CheckmarkIcon({ size = '14px', className }: IIconProps) {
  return (
    <IconWrapper size={size} className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 10.625L7.26087 15L17 5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
